// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1SnmF","signatureBlock":"Footer_signatureBlock__3LQCG","signature":"Footer_signature__3QiT6"};